module.exports = __webpack_public_path__ + "img/side seam.e7b8e051.png";